import { fromJS } from "immutable"

export const addItem = (state, action) => state.setIn(['items', action.payload.pk.toString()], fromJS(action.payload))
export const updateItem = (state, action) => state.setIn(['items', action.payload.pk.toString()], fromJS(action.payload.itemData))
export const deleteItem = (state, action) => state.removeIn(['items', action.payload.pk.toString()])
export const updateOrder = (state, action) => state.setIn(['order'], fromJS(action.payload.itemsList))
export const updateFractalOrder = (state, action) => state.setIn(['items', action.payload.pk.toString(), 'order'], fromJS(action.payload.order))